'use strict';

var _extend2 = _interopRequireDefault(require("lodash/extend"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var input = args[0];

  if (!(0, _isObject2.default)(input)) {
    input = {
      name: input,
      message: input
    };
  }

  var error = (0, _extend2.default)(new Error(input.message), input); // TODO: Remove top of stack

  error.message = darc.formatMessage(error.message, args.slice(1));
  error.darc = true;
  return error;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9zeXN0ZW0vZXJyb3IuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsImFyZ3MiLCJpbnB1dCIsIm5hbWUiLCJtZXNzYWdlIiwiZXJyb3IiLCJFcnJvciIsImRhcmMiLCJmb3JtYXRNZXNzYWdlIiwic2xpY2UiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OztBQUlBQSxPQUFPQyxPQUFQLEdBQWlCLFlBQW9CO0FBQUEsb0NBQVBDLElBQU87QUFBUEEsUUFBTztBQUFBOztBQUVwQyxNQUFJQyxRQUFRRCxLQUFNLENBQU4sQ0FBWjs7QUFFQSxNQUFLLENBQUMsd0JBQVlDLEtBQVosQ0FBTixFQUE0QjtBQUUzQkEsWUFBUTtBQUVQQyxZQUFNRCxLQUZDO0FBR1BFLGVBQVNGO0FBSEYsS0FBUjtBQU9BOztBQUVELE1BQUlHLFFBQVEsc0JBQVUsSUFBSUMsS0FBSixDQUFXSixNQUFNRSxPQUFqQixDQUFWLEVBQXNDRixLQUF0QyxDQUFaLENBZm9DLENBaUJwQzs7QUFFQUcsUUFBTUQsT0FBTixHQUFnQkcsS0FBS0MsYUFBTCxDQUFvQkgsTUFBTUQsT0FBMUIsRUFBbUNILEtBQUtRLEtBQUwsQ0FBWSxDQUFaLENBQW5DLENBQWhCO0FBQ0FKLFFBQU1FLElBQU4sR0FBYSxJQUFiO0FBRUEsU0FBT0YsS0FBUDtBQUVBLENBeEJEIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuXG5pbXBvcnQgXyBmcm9tICdsb2Rhc2gnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uKCAuLi5hcmdzICkge1xuXG5cdHZhciBpbnB1dCA9IGFyZ3NbIDAgXTtcblxuXHRpZiAoICFfLmlzT2JqZWN0KCBpbnB1dCApICkge1xuXG5cdFx0aW5wdXQgPSB7XG5cblx0XHRcdG5hbWU6IGlucHV0LFxuXHRcdFx0bWVzc2FnZTogaW5wdXRcblxuXHRcdH07XG5cblx0fVxuXG5cdHZhciBlcnJvciA9IF8uZXh0ZW5kKCBuZXcgRXJyb3IoIGlucHV0Lm1lc3NhZ2UgKSwgaW5wdXQgKTtcblxuXHQvLyBUT0RPOiBSZW1vdmUgdG9wIG9mIHN0YWNrXG5cblx0ZXJyb3IubWVzc2FnZSA9IGRhcmMuZm9ybWF0TWVzc2FnZSggZXJyb3IubWVzc2FnZSwgYXJncy5zbGljZSggMSApICk7XG5cdGVycm9yLmRhcmMgPSB0cnVlO1xuXG5cdHJldHVybiBlcnJvcjtcblxufTsiXX0=